import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/projectStrategicAxisEdition/scoreTag/styles.scss';export default {
  "tag": "_tag_1ym15_1",
  "positiveTag": "_positiveTag_1ym15_7",
  "negativeTag": "_negativeTag_1ym15_11"
};